import {useState} from "react"; 
const FormInput = ({label, placeholder, onChange, value, required, errorMessage, pattern,inputType, name })=>{
  const [focus, setFocus] =  useState("false"); 
const changeFocus = ()=>{
  console.log("change focus has been called"); 
  console.log("something is wrong somewhere"); 
  setFocus("true"); 
}

  return(
	  <div>
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <input
              className="mt-1 w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder={placeholder}
				  onChange = {onChange}
				  value = {value}
				  required
				  pattern = {pattern}
				  name = {name}
				  type = { `${inputType === "password" ? "password" : `${inputType}`}`}
				  focused = {focus}
				  onBlur = {changeFocus}
            />
				<span className = "text-red-500"> {errorMessage} </span>
      </div>

  ); 
}
export default FormInput; 
